import { call, put, takeEvery } from 'redux-saga/effects';
import type { Saga } from 'redux-saga';

import {
  AB_TEST,
  gwpAbTestRequest,
  gwpAbTestSucess,
  gwpAbTestFailure,
} from 'pages/MyAccount/services/actions/abTestActions';

import type { GwpAbTestRequest } from 'pages/MyAccount/services/actions/abTestActions';
import { getGwpTest } from '../../services/abTestWrapper';

const { GWP_AB_TEST_TRIGGER } = AB_TEST;

// WORKER SAGA
function* fetchAbTestUserData(action: GwpAbTestRequest): Saga<void> {
  try {
    yield put(gwpAbTestRequest());
    const response = yield call(getGwpTest);
    yield put(gwpAbTestSucess(response));
  } catch (error) {
    yield put(gwpAbTestFailure(error));
  }
}

// WATCHER SAGAS
export function* watchFetchAbTestUserData(): Saga<void> {
  yield takeEvery(GWP_AB_TEST_TRIGGER, fetchAbTestUserData);
}
